import type { Dtos, SuretyAccountId, SuretyIndemnityAgreementId } from "@inrev/common";
import {
	FileType,
	IndemnityAgreementSignatureMethod,
	IndemnityAttachmentTypeLabelMap,
	IndemnityStatus,
} from "@inrev/common";
import { Text } from "@portal/components/primitives";
import { indemnityAgreementSignatureMethodTypeDisplayMap } from "../../../../../../../../constants";
import { useScrollToId } from "../../../../../../../../utils";
import { AccountIndemnitorList } from "../components/AccountIndemnitorList";
import { IndemnityAgreementAttachmentCard } from "../components/IndemnityAgreementAttachmentCard";
import { IndemnityAgreementStatusIndicator } from "../components/IndemnityAgreementStatusIndicator";
import { IndemnityAgreementSectionLayout } from "../layout/IndemnityAgreementLayout";

type CompletedIndemnityAgreement = {
	id: SuretyIndemnityAgreementId;
	signatureMethod: IndemnityAgreementSignatureMethod;
	indemnitors: Dtos.SuretyAccount.IndemnityAgreement.Get.Response["indemnitors"];
};

export type CompletedIndemnityAgreementSectionProps = {
	accountId: SuretyAccountId;
	indemnityAgreement: CompletedIndemnityAgreement;
};

export const CompletedIndemnityAgreementSection = ({
	accountId,
	indemnityAgreement,
}: CompletedIndemnityAgreementSectionProps) => {
	const domReadyRef = useScrollToId("start");

	return (
		<IndemnityAgreementSectionLayout
			domReadyRef={domReadyRef}
			status={
				<IndemnityAgreementStatusIndicator
					status={IndemnityStatus.complete}
					signatureMethod={indemnityAgreement.signatureMethod}
				/>
			}
			signatureMethod={
				<Text type="body" color="primary">
					{indemnityAgreementSignatureMethodTypeDisplayMap[indemnityAgreement.signatureMethod]}
				</Text>
			}
			requiredIndemnitors={
				<AccountIndemnitorList
					indemnitors={indemnityAgreement.indemnitors}
					showESignatureDetails={
						indemnityAgreement.signatureMethod === IndemnityAgreementSignatureMethod.electronic
					}
				/>
			}
			body={
				<div className="flex flex-col space-y-[8px] py-[10px] pb-[20px]">
					<Text type="title" color="primary" className="mb-2">
						{IndemnityAttachmentTypeLabelMap[FileType.indemnity_agreement]}
					</Text>
					<IndemnityAgreementAttachmentCard
						suretyAccountId={accountId}
						indemnityAgreementId={indemnityAgreement.id}
						isComplete
					/>
				</div>
			}
			bodyTestId="agent-account-completed-indemnity-card"
		/>
	);
};
